import { render, staticRenderFns } from "./retirement.vue?vue&type=template&id=058a8fce&scoped=true&"
import script from "./retirement.vue?vue&type=script&lang=js&"
export * from "./retirement.vue?vue&type=script&lang=js&"
import style0 from "./retirement.vue?vue&type=style&index=0&id=058a8fce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a8fce",
  null
  
)

export default component.exports